import { Injectable } from "@angular/core";
import { INgsiMapBaseEntity } from "../../ngsild/interfaces/ngsi-entity.interface";
import { IMapWidgetFormGroupSettings } from "../../../map-widget-settings/map-widget-settings.interface";
import { ILeafletInstance } from "../leaflet.interface";
import { RouteTracking } from "../route-tracking";
import { INgsiAIS } from "../../ngsild/interfaces/ngsi-ais.interface";
import L from "../leaflet-plugins-loader";
import { LeafletService } from "../leaflet.service";
import * as leafletInstanceConfig from "../../ngsild/helpers/leaflet-instance-config.constants";

type LeafletLatLng = [number, number];

@Injectable({
  providedIn: "root",
})
export class PolygonService {
  constructor(private readonly leafletService: LeafletService) {}

  addOrUpdatePolygon(
    appPluginWidgetId: string,
    entity: INgsiMapBaseEntity,
    settings: IMapWidgetFormGroupSettings,
    instance: ILeafletInstance,
    polyLineType: string,
  ) {
    if (
      entity.type ===
      leafletInstanceConfig.config.dataSourceSelector.MMSI.value.type
    ) {
      const eAis = entity as INgsiAIS;

      if (settings.enableRouteTracking && polyLineType === "tracking") {
        RouteTracking.trackingDepositedRoute(
          eAis,
          instance,
          false,
          settings.durationTime,
          settings.maxTrackPoints,
        );
      }

      if (
        settings.enableAisPrediction &&
        polyLineType === "prediction" &&
        eAis?.pcog?.type === "LineString"
      ) {
        this.drawPredictionLine(appPluginWidgetId, eAis, instance);
      }

      if (!settings.enableRouteTracking) {
        RouteTracking.stopRouteTracking(eAis, instance);
        RouteTracking.stopPeriodicCheck();
      }
    }
  }

  private drawPredictionLine(
    appPluginWidgetId: string,
    entity: INgsiAIS,
    instance: ILeafletInstance,
  ): void {
    let polyLine = instance.polygons.get(entity.id);

    instance.map.createPane("predictionLineOverlayPane");
    const predictionLineOverlayPane = instance.map.getPane(
      "predictionLineOverlayPane",
    );

    if (predictionLineOverlayPane) {
      predictionLineOverlayPane.style.zIndex = "350"; // Ensure it is rendered below markers
    }

    if (entity?.pcog?.coordinates) {
      const lineString = entity.pcog.coordinates as unknown as [
        number,
        number,
      ][];
      // Convert LineString (long/lat) to Leaflet (lat/long)
      const leafletCoordinates = lineString.map(
        (coords: [number, number]): LeafletLatLng => [coords[1], coords[0]],
      );

      if (!polyLine) {
        const spineOptions = {
          color: "#F5D76E",
          weight: 3,
          dashArray: "5,5",
          lineJoin: "miter",
          lineCap: "square",
          smoothing: 0.15,
          pane: "predictionLineOverlayPane",
        } as any;

        const splinePolyline = L.spline(
          leafletCoordinates,
          spineOptions,
        ) as unknown as L.Polyline<any>;

        instance.polygons.set(entity.id, splinePolyline);

        this.leafletService.addLayerByType(
          appPluginWidgetId,
          entity.type,
          instance,
        );
        this.leafletService.addPolylineToLayer(
          appPluginWidgetId,
          entity.type,
          splinePolyline,
          instance,
        );
      } else {
        polyLine.setLatLngs(leafletCoordinates);
        instance.polygons.set(entity.id, polyLine);

        this.leafletService.addPolylineToLayer(
          appPluginWidgetId,
          entity.type,
          polyLine,
          instance,
        );
      }
    }
  }
}
